import * as i0 from '@angular/core';
import * as i1 from './chat.module';
import * as i2 from '@angular/common';
import * as i3 from '@angular/forms';
import * as i4 from '@angular/router';
import * as i5 from './chat.component';
import * as i6 from './chat-message.component';
import * as i7 from './chat-form.component';
import * as i8 from './chat-message-map.component';
import * as i9 from './chat-message-text.component';
import * as i10 from './chat-message-file.component';
import * as i11 from './chat-message-quote.component';
import * as i12 from './chat-message-custom.component';
import * as i13 from './chat-message-options-list.component';
import * as i14 from '../shared/shared.module';
export const NbChatModuleNgFactory:i0.NgModuleFactory<i1.NbChatModule> = (null as any);
var _decl0_0:i2.NgClass = (<any>(null as any));
var _decl0_1:i2.NgComponentOutlet = (<any>(null as any));
var _decl0_2:i2.NgForOf<any> = (<any>(null as any));
var _decl0_3:i2.NgIf = (<any>(null as any));
var _decl0_4:i2.NgTemplateOutlet = (<any>(null as any));
var _decl0_5:i2.NgStyle = (<any>(null as any));
var _decl0_6:i2.NgSwitch = (<any>(null as any));
var _decl0_7:i2.NgSwitchCase = (<any>(null as any));
var _decl0_8:i2.NgSwitchDefault = (<any>(null as any));
var _decl0_9:i2.NgPlural = (<any>(null as any));
var _decl0_10:i2.NgPluralCase = (<any>(null as any));
var _decl0_11:i3.ɵangular_packages_forms_forms_bh = (<any>(null as any));
var _decl0_12:i3.NgSelectOption = (<any>(null as any));
var _decl0_13:i3.ɵangular_packages_forms_forms_s = (<any>(null as any));
var _decl0_14:i3.DefaultValueAccessor = (<any>(null as any));
var _decl0_15:i3.ɵangular_packages_forms_forms_be = (<any>(null as any));
var _decl0_16:i3.ɵangular_packages_forms_forms_bg = (<any>(null as any));
var _decl0_17:i3.CheckboxControlValueAccessor = (<any>(null as any));
var _decl0_18:i3.SelectControlValueAccessor = (<any>(null as any));
var _decl0_19:i3.SelectMultipleControlValueAccessor = (<any>(null as any));
var _decl0_20:i3.RadioControlValueAccessor = (<any>(null as any));
var _decl0_21:i3.NgControlStatus = (<any>(null as any));
var _decl0_22:i3.NgControlStatusGroup = (<any>(null as any));
var _decl0_23:i3.RequiredValidator = (<any>(null as any));
var _decl0_24:i3.MinLengthValidator = (<any>(null as any));
var _decl0_25:i3.MaxLengthValidator = (<any>(null as any));
var _decl0_26:i3.PatternValidator = (<any>(null as any));
var _decl0_27:i3.CheckboxRequiredValidator = (<any>(null as any));
var _decl0_28:i3.EmailValidator = (<any>(null as any));
var _decl0_29:i3.NgModel = (<any>(null as any));
var _decl0_30:i3.NgModelGroup = (<any>(null as any));
var _decl0_31:i3.NgForm = (<any>(null as any));
var _decl0_32:i3.NgFormSelectorWarning = (<any>(null as any));
var _decl0_33:i4.RouterOutlet = (<any>(null as any));
var _decl0_34:i4.RouterLink = (<any>(null as any));
var _decl0_35:i4.RouterLinkWithHref = (<any>(null as any));
var _decl0_36:i4.RouterLinkActive = (<any>(null as any));
var _decl0_37:i4.ɵEmptyOutletComponent = (<any>(null as any));
var _decl0_38:i5.NbChatComponent = (<any>(null as any));
var _decl0_39:i6.NbChatMessageComponent = (<any>(null as any));
var _decl0_40:i7.NbChatFormComponent = (<any>(null as any));
var _decl0_41:i8.NbChatMessageMapComponent = (<any>(null as any));
var _decl0_42:i9.NbChatMessageTextComponent = (<any>(null as any));
var _decl0_43:i10.NbChatMessageFileComponent = (<any>(null as any));
var _decl0_44:i11.NbChatMessageQuoteComponent = (<any>(null as any));
var _decl0_45:i12.NbChatMessageCustomComponent = (<any>(null as any));
var _decl0_46:i13.NbChatMessageOptionsListComponent = (<any>(null as any));
var _decl0_47:i2.AsyncPipe = (<any>(null as any));
var _decl0_48:i2.UpperCasePipe = (<any>(null as any));
var _decl0_49:i2.LowerCasePipe = (<any>(null as any));
var _decl0_50:i2.JsonPipe = (<any>(null as any));
var _decl0_51:i2.SlicePipe = (<any>(null as any));
var _decl0_52:i2.DecimalPipe = (<any>(null as any));
var _decl0_53:i2.PercentPipe = (<any>(null as any));
var _decl0_54:i2.TitleCasePipe = (<any>(null as any));
var _decl0_55:i2.CurrencyPipe = (<any>(null as any));
var _decl0_56:i2.DatePipe = (<any>(null as any));
var _decl0_57:i2.I18nPluralPipe = (<any>(null as any));
var _decl0_58:i2.I18nSelectPipe = (<any>(null as any));
var _decl0_59:i2.KeyValuePipe = (<any>(null as any));
var _decl0_60:i14.NbSharedModule = (<any>(null as any));
var _decl0_61:i0.TemplateRef<any> = (<any>(null as any));
var _decl0_62:i0.ElementRef<any> = (<any>(null as any));
function _View_NbChatComponent_Host_1_0():void {
  var _any:any = (null as any);
  const currVal_0:any = _decl0_38.xxsmall;
  currVal_0;
  const currVal_1:any = _decl0_38.xsmall;
  currVal_1;
  const currVal_2:any = _decl0_38.small;
  currVal_2;
  const currVal_3:any = _decl0_38.medium;
  currVal_3;
  const currVal_4:any = _decl0_38.large;
  currVal_4;
  const currVal_5:any = _decl0_38.xlarge;
  currVal_5;
  const currVal_6:any = _decl0_38.xxlarge;
  currVal_6;
  const currVal_7:any = _decl0_38.active;
  currVal_7;
  const currVal_8:any = _decl0_38.disabled;
  currVal_8;
  const currVal_9:any = _decl0_38.primary;
  currVal_9;
  const currVal_10:any = _decl0_38.info;
  currVal_10;
  const currVal_11:any = _decl0_38.success;
  currVal_11;
  const currVal_12:any = _decl0_38.warning;
  currVal_12;
  const currVal_13:any = _decl0_38.danger;
  currVal_13;
  const currVal_14:any = _decl0_38.hasAccent;
  currVal_14;
}
function _View_NbChatComponent_1_1():void {
  if (!((_decl0_38.messages == null)? (null as any): _decl0_38.messages.length)) { var _any:any = (null as any); }
}
function _View_NbChatComponent_1_0():void {
  var _any:any = (null as any);
  const currVal_0:any = _decl0_38.title;
  currVal_0;
  const currVal_1:any = !((_decl0_38.messages == null)? (null as any): _decl0_38.messages.length);
  currVal_1;
}
function _View_NbChatMessageComponent_Host_2_0():void {
  var _any:any = (null as any);
  const currVal_0:any = _decl0_39.flyInOut;
  currVal_0;
  const currVal_1:any = _decl0_39.replyValue;
  currVal_1;
  const currVal_2:any = _decl0_39.notReply;
  currVal_2;
}
function _View_NbChatMessageComponent_2_2():void {
  if ((!_decl0_39.replyValue && !_decl0_39.avatarStyle)) {
    var _any:any = (null as any);
    const currVal_0:any = _decl0_39.getInitials();
    currVal_0;
  }
}
function _View_NbChatMessageComponent_2_1():void {
  if (!_decl0_39.replyValue) {
    var _any:any = (null as any);
    const currVal_0:any = _decl0_39.avatarStyle;
    currVal_0;
    const currVal_1:any = !_decl0_39.avatarStyle;
    currVal_1;
  }
}
function _View_NbChatMessageComponent_2_3():void {
  var _any:any = (null as any);
  const currVal_0:any = _decl0_39.message;
  currVal_0;
  const currVal_1:any = _decl0_39.sender;
  currVal_1;
  const currVal_2:any = _decl0_39.date;
  currVal_2;
  const currVal_3:any = _decl0_39.files;
  currVal_3;
}
function _View_NbChatMessageComponent_2_4():void {
  var _any:any = (null as any);
  const currVal_0:any = _decl0_39.message;
  currVal_0;
  const currVal_1:any = _decl0_39.sender;
  currVal_1;
  const currVal_2:any = _decl0_39.date;
  currVal_2;
  const currVal_3:any = _decl0_39.quote;
  currVal_3;
}
function _View_NbChatMessageComponent_2_5():void {
  var _any:any = (null as any);
  const currVal_0:any = _decl0_39.message;
  currVal_0;
  const currVal_1:any = _decl0_39.sender;
  currVal_1;
  const currVal_2:any = _decl0_39.date;
  currVal_2;
  const currVal_3:any = _decl0_39.latitude;
  currVal_3;
  const currVal_4:any = _decl0_39.longitude;
  currVal_4;
}
function _View_NbChatMessageComponent_2_6():void {
  var _any:any = (null as any);
  const currVal_0:any = _decl0_39.sender;
  currVal_0;
  const currVal_1:any = _decl0_39.options;
  currVal_1;
  const currVal_2:any = _decl0_39.date;
  currVal_2;
  const currVal_3:any = _decl0_39.message;
  currVal_3;
  const pd_4:any = ((<any>_decl0_39.handleAlternativeUserInput(_any)) !== false);
}
function _View_NbChatMessageComponent_2_7():void {
  var _any:any = (null as any);
  const currVal_0:any = _decl0_39.sender;
  currVal_0;
  const currVal_1:any = _decl0_39.date;
  currVal_1;
}
function _View_NbChatMessageComponent_2_8():void {
  var _any:any = (null as any);
  const currVal_0:any = _decl0_39.sender;
  currVal_0;
  const currVal_1:any = _decl0_39.message;
  currVal_1;
  const currVal_2:any = _decl0_39.date;
  currVal_2;
}
function _View_NbChatMessageComponent_2_0():void {
  var _any:any = (null as any);
  const currVal_0:any = !_decl0_39.replyValue;
  currVal_0;
  const currVal_1:any = _decl0_39.type;
  currVal_1;
  const currVal_2:any = 'file';
  currVal_2;
  const currVal_3:any = 'quote';
  currVal_3;
  const currVal_4:any = 'map';
  currVal_4;
  const currVal_5:any = 'list';
  currVal_5;
  const currVal_6:any = 'custom';
  currVal_6;
}
function _View_NbChatFormComponent_Host_3_0():void {
  var _any:any = (null as any);
  const currVal_0:any = _decl0_40.fileOver;
  currVal_0;
  const pd_1:any = ((<any>_decl0_40.onDrop(_any)) !== false);
  const pd_2:any = ((<any>_decl0_40.onDragOver()) !== false);
  const pd_3:any = ((<any>_decl0_40.onDragLeave()) !== false);
}
function _View_NbChatFormComponent_3_3():void {
  if ((((_decl0_40.droppedFiles == null)? (null as any): _decl0_40.droppedFiles.length) && _any.urlStyle)) {
    var _any:any = (null as any);
    const currVal_0:any = _any.urlStyle;
    currVal_0;
    const pd_1:any = ((<any>_decl0_40.removeFile(_any)) !== false);
  }
}
function _View_NbChatFormComponent_3_4():void {
  if ((((_decl0_40.droppedFiles == null)? (null as any): _decl0_40.droppedFiles.length) && !_any.urlStyle)) {
    var _any:any = (null as any);
    const pd_0:any = ((<any>_decl0_40.removeFile(_any)) !== false);
  }
}
function _View_NbChatFormComponent_3_2():void {
  if (((_decl0_40.droppedFiles == null)? (null as any): _decl0_40.droppedFiles.length)) {
    var _any:any = (null as any);
    const currVal_0:any = _any.urlStyle;
    currVal_0;
    const currVal_1:any = !_any.urlStyle;
    currVal_1;
  }
}
function _View_NbChatFormComponent_3_1():void {
  if (((_decl0_40.droppedFiles == null)? (null as any): _decl0_40.droppedFiles.length)) {
    var _any:any = (null as any);
    const currVal_0:any = _decl0_40.droppedFiles;
    currVal_0;
  }
}
function _View_NbChatFormComponent_3_6():void {
  if ((_decl0_40.showButton && !_decl0_40.buttonTitle)) {
    var _any:any = (null as any);
    const currVal_0:any = _decl0_40.buttonIcon;
    currVal_0;
  }
}
function _View_NbChatFormComponent_3_5():void {
  if (_decl0_40.showButton) {
    var _any:any = (null as any);
    const currVal_0:any = !_decl0_40.buttonTitle;
    currVal_0;
    const currVal_1:any = _decl0_40.buttonTitle;
    currVal_1;
    const currVal_2:any = !_decl0_40.buttonTitle;
    currVal_2;
    const pd_3:any = ((<any>_decl0_40.sendMessage()) !== false);
  }
}
function _View_NbChatFormComponent_3_0():void {
  var _any:any = (null as any);
  const currVal_0:any = ((_decl0_40.droppedFiles == null)? (null as any): _decl0_40.droppedFiles.length);
  currVal_0;
  const currVal_1:any = _decl0_40.message;
  currVal_1;
  const currVal_2:any = _decl0_21.ngClassUntouched;
  currVal_2;
  const currVal_3:any = _decl0_21.ngClassTouched;
  currVal_3;
  const currVal_4:any = _decl0_21.ngClassPristine;
  currVal_4;
  const currVal_5:any = _decl0_21.ngClassDirty;
  currVal_5;
  const currVal_6:any = _decl0_21.ngClassValid;
  currVal_6;
  const currVal_7:any = _decl0_21.ngClassInvalid;
  currVal_7;
  const currVal_8:any = _decl0_21.ngClassPending;
  currVal_8;
  const currVal_9:any = _decl0_40.showButton;
  currVal_9;
  const currVal_10:any = i0.ɵinlineInterpolate(1,'',(_decl0_40.fileOver? 'Drop file to send': 'Type a message'),
      '');
  currVal_10;
  const currVal_11:any = _decl0_40.showButton;
  currVal_11;
  const pd_12:any = ((<any>(<any>_decl0_14)._handleInput(_any.target.value)) !== false);
  const pd_13:any = ((<any>_decl0_14.onTouched()) !== false);
  const pd_14:any = ((<any>(<any>_decl0_14)._compositionStart()) !== false);
  const pd_15:any = ((<any>(<any>_decl0_14)._compositionEnd(_any.target.value)) !== false);
  const pd_16:any = ((<any>(_decl0_40.message = _any)) !== false);
  const pd_17:any = ((<any>_decl0_40.sendMessage()) !== false);
}
function _View_NbChatMessageMapComponent_Host_4_0():void {
  var _any:any = (null as any);
}
function _View_NbChatMessageMapComponent_4_0():void {
  var _any:any = (null as any);
  const currVal_0:any = _decl0_41.message;
  currVal_0;
  const currVal_1:any = _decl0_41.sender;
  currVal_1;
  const currVal_2:any = _decl0_41.date;
  currVal_2;
  const currVal_3:any = [_decl0_41.file];
  currVal_3;
}
function _View_NbChatMessageTextComponent_Host_5_0():void {
  var _any:any = (null as any);
}
function _View_NbChatMessageTextComponent_5_1():void {
  if ((_decl0_42.sender || _decl0_42.date)) {
    var _any:any = (null as any);
    const currVal_0:any = _decl0_42.sender;
    currVal_0;
    const currVal_1:any = _decl0_56.transform(_decl0_42.date,'shortTime');
    currVal_1;
  }
}
function _View_NbChatMessageTextComponent_5_2():void {
  if (_decl0_42.message) {
    var _any:any = (null as any);
    const currVal_0:any = _decl0_42.message;
    currVal_0;
  }
}
function _View_NbChatMessageTextComponent_5_0():void {
  var _any:any = (null as any);
  const currVal_0:any = (_decl0_42.sender || _decl0_42.date);
  currVal_0;
  const currVal_1:any = _decl0_42.message;
  currVal_1;
}
function _View_NbChatMessageFileComponent_Host_6_0():void {
  var _any:any = (null as any);
}
function _View_NbChatMessageFileComponent_6_3():void {
  if (((((_decl0_43.readyFiles == null)? (null as any): _decl0_43.readyFiles.length) > 1) && !_any.urlStyle)) {
    var _any:any = (null as any);
    const currVal_0:any = _any.icon;
    currVal_0;
  }
}
function _View_NbChatMessageFileComponent_6_4():void {
  if (((((_decl0_43.readyFiles == null)? (null as any): _decl0_43.readyFiles.length) > 1) && _any.isImage)) {
    var _any:any = (null as any);
    const currVal_0:any = _any.urlStyle;
    currVal_0;
  }
}
function _View_NbChatMessageFileComponent_6_2():void {
  if ((((_decl0_43.readyFiles == null)? (null as any): _decl0_43.readyFiles.length) > 1)) {
    var _any:any = (null as any);
    const currVal_0:any = _any.url;
    currVal_0;
    const currVal_1:any = !_any.urlStyle;
    currVal_1;
    const currVal_2:any = _any.isImage;
    currVal_2;
  }
}
function _View_NbChatMessageFileComponent_6_1():void {
  if ((((_decl0_43.readyFiles == null)? (null as any): _decl0_43.readyFiles.length) > 1)) {
    var _any:any = (null as any);
    const currVal_0:any = _decl0_43.readyFiles;
    currVal_0;
  }
}
function _View_NbChatMessageFileComponent_6_6():void {
  if (((((_decl0_43.readyFiles == null)? (null as any): _decl0_43.readyFiles.length) === 1) && !_decl0_43.readyFiles[0].urlStyle)) {
    var _any:any = (null as any);
    const currVal_0:any = _decl0_43.readyFiles[0].icon;
    currVal_0;
  }
}
function _View_NbChatMessageFileComponent_6_7():void {
  if (((((_decl0_43.readyFiles == null)? (null as any): _decl0_43.readyFiles.length) === 1) && _decl0_43.readyFiles[0].isImage)) {
    var _any:any = (null as any);
    const currVal_0:any = _decl0_43.readyFiles[0].urlStyle;
    currVal_0;
  }
}
function _View_NbChatMessageFileComponent_6_5():void {
  if ((((_decl0_43.readyFiles == null)? (null as any): _decl0_43.readyFiles.length) === 1)) {
    var _any:any = (null as any);
    const currVal_0:any = _decl0_43.readyFiles[0].url;
    currVal_0;
    const currVal_1:any = !_decl0_43.readyFiles[0].urlStyle;
    currVal_1;
    const currVal_2:any = _decl0_43.readyFiles[0].isImage;
    currVal_2;
  }
}
function _View_NbChatMessageFileComponent_6_0():void {
  var _any:any = (null as any);
  const currVal_0:any = _decl0_43.sender;
  currVal_0;
  const currVal_1:any = _decl0_43.message;
  currVal_1;
  const currVal_2:any = _decl0_43.date;
  currVal_2;
  const currVal_3:any = _decl0_43.message;
  currVal_3;
  const currVal_4:any = (((_decl0_43.readyFiles == null)? (null as any): _decl0_43.readyFiles.length) > 1);
  currVal_4;
  const currVal_5:any = (((_decl0_43.readyFiles == null)? (null as any): _decl0_43.readyFiles.length) === 1);
  currVal_5;
}
function _View_NbChatMessageQuoteComponent_Host_7_0():void {
  var _any:any = (null as any);
}
function _View_NbChatMessageQuoteComponent_7_1():void {
  if ((_decl0_44.sender || _decl0_44.date)) {
    var _any:any = (null as any);
    const currVal_0:any = _decl0_44.sender;
    currVal_0;
    const currVal_1:any = _decl0_56.transform(_decl0_44.date,'shortTime');
    currVal_1;
  }
}
function _View_NbChatMessageQuoteComponent_7_0():void {
  var _any:any = (null as any);
  const currVal_0:any = (_decl0_44.sender || _decl0_44.date);
  currVal_0;
  const currVal_1:any = _decl0_44.quote;
  currVal_1;
  const currVal_2:any = _decl0_44.message;
  currVal_2;
  const currVal_3:any = _decl0_44.message;
  currVal_3;
}
function _View_NbChatMessageCustomComponent_Host_8_0():void {
  var _any:any = (null as any);
}
function _View_NbChatMessageCustomComponent_8_1():void {
  if ((_decl0_45.sender || _decl0_45.date)) {
    var _any:any = (null as any);
    const currVal_0:any = _decl0_45.sender;
    currVal_0;
    const currVal_1:any = _decl0_56.transform(_decl0_45.date,'shortTime');
    currVal_1;
  }
}
function _View_NbChatMessageCustomComponent_8_0():void {
  var _any:any = (null as any);
  const currVal_0:any = (_decl0_45.sender || _decl0_45.date);
  currVal_0;
}
function _View_NbChatMessageOptionsListComponent_Host_9_0():void {
  var _any:any = (null as any);
}
function _View_NbChatMessageOptionsListComponent_9_1():void {
  if ((_decl0_46.sender || _decl0_46.date)) {
    var _any:any = (null as any);
    const currVal_0:any = _decl0_46.sender;
    currVal_0;
    const currVal_1:any = _decl0_56.transform(_decl0_46.date,'shortTime');
    currVal_1;
  }
}
function _View_NbChatMessageOptionsListComponent_9_2():void {
  var _any:any = (null as any);
  const currVal_0:any = _any.text;
  currVal_0;
  const pd_1:any = ((<any>_decl0_46.chooseOption(_any.value)) !== false);
}
function _View_NbChatMessageOptionsListComponent_9_0():void {
  var _any:any = (null as any);
  const currVal_0:any = (_decl0_46.sender || _decl0_46.date);
  currVal_0;
  const currVal_1:any = _decl0_46.options;
  currVal_1;
}
